<script setup>
import { useElementSize } from '@vueuse/core'
import { ref, watch } from 'vue'
import { computed } from 'vue'

const COMPACT_MODE_WIDTH = 250
const TYPES = ['error', 'warning']
const DEFAULT_TYPE = 'error'

const props = defineProps({
  message: {
    type: String,
    default: ''
  },

  isShow: {
    type: Boolean,
    default: false
  },

  type: {
    type: String,
    default: 'error'
  }
})

const alertWrapper = ref(null)
const { width } = useElementSize(alertWrapper)

const isCompactMode = computed(() => {
  return width.value <= COMPACT_MODE_WIDTH
})

const classes = computed(() => {
  return [
    'alert-box',
    isCompactMode.value && 'alert-box_is-compact',
    `alert-box_type_${TYPES.includes(props.type) ? props.type : DEFAULT_TYPE}`
  ]
})

const scrollToAlert = () => {
  // Если нужно будет прокручивать до самого верха с вычетом высоты хедера
  // if (alertWrapper.value) {
  //   const el = alertWrapper.value
  //   const offset = el.getBoundingClientRect().top + window.scrollY
  //   const topOffset = 150;

  //   window.scrollTo({
  //     top: offset - topOffset,
  //     behavior: 'smooth'
  //   })
  // }
  if (alertWrapper.value) {
    alertWrapper.value.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}

watch(() => props.isShow, (newValue) => {
  if (newValue) {
    setTimeout(scrollToAlert, 100)
  }
})
</script>

<template>
  <transition
    name="alert-slide"
    enter-active-class="alert-slide-enter-active"
    leave-active-class="alert-slide-leave-active"
    enter-from-class="alert-slide-enter-from"
    leave-to-class="alert-slide-leave-to"
  >
    <div v-if="isShow" ref="alertWrapper" class="alert-wrapper">
      <div
        :class="classes"
      >
        <slot>
          <div class="body">
            <kp-icon name="circle_attention" size="20" />

            <div class="message">
              {{ message }}
            </div>
          </div>
        </slot>
        </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
  .alert-wrapper {
    margin: 5px 0;
  }

  .alert-box {
    display: flex;
    align-items: center;
    min-height: 52px;
    padding: 13px 40px 13px 13px;
    background-image: url('/assets/img/attention_bg.svg');
    background-repeat: no-repeat;
    background-position: right bottom;
    background-size: auto;
    border-radius: 12px;
    position: relative;

    .body {
      display: flex;
      align-items: center;
    }

    .icon {
      flex-shrink: 0;
      fill: #9a2b0b;
      margin-right: 8px;
    }

    .message {
      font-size: 12px;
      line-height: 120%;
    }

    &_is-compact {
      padding: 10px;
      min-height: initial;
    }

    &_type_error {
      background-color: #f3efe9;
      color: #9a2b0b;
    }

    &_type_warning {
      background-color: #f2a43b;
      color: #ffffff;
      background-image: initial;
    }
  }

  .alert-slide-enter-active,
  .alert-slide-leave-active {
    transition: all 0.3s ease-out;
    overflow: hidden;
  }

  .alert-slide-enter-from,
  .alert-slide-leave-to {
    opacity: 0;
    transform: translateY(-10px);
    height: 0;
    margin: 0;
  }
</style>
